import React, { useState } from 'react'
import Logo from "../../assets/static/img/whanson-logo.png"
import { Input } from 'antd';
import { useNavigate } from 'react-router-dom';

const SecureLogin = () => {

    const [show_password, setShowPassword] = useState(false);
    const [password, setPassword] = useState("");
    const [error, setError] = useState(false);

    const navigate = useNavigate();

    const onHandleLogin = (e) => {
        e.preventDefault();
        if (password == "Whanson@#2023") {
            navigate('/');
            localStorage.setItem('auth_user', 'Whanson@#2023')
        } else {
            setError(true)
        }
    }
    return (
        <div>
            <form className="ps-form--account pt-0 login-admin" onSubmit={onHandleLogin} >
                <div className="ps-tab active border-radius3 bd-admin-login">
                    <div className="ps-form__content p-5 ">
                        <div className='text-center mb-4'>
                            <img src={Logo} loading="lazy" alt='No Logo' />
                        </div>
                        <h3 className="pb-20 text-center">Log In Your Account to Continue</h3>
                        <div className="form-group form-forgot ">
                            <div className="position-relative">
                                <Input
                                    className="form-control "
                                    type={show_password ? "text" : "password"}
                                    placeholder="Password..."
                                    onChange={(e) => {
                                        setPassword(e.target.value)
                                        setError(false)
                                    }}
                                />
                                <div className="bd-eye-open">
                                    <span onClick={() => setShowPassword(!show_password)}>
                                        <i
                                            className={
                                                show_password ? "icon-eye" : "icon-eye-crossed"
                                            }
                                        ></i>
                                    </span>
                                </div>
                            </div>
                            {error == true ? (
                                <span className="text-danger font-12">
                                    Please Enter Correct Password
                                </span>
                            ) : null}
                        </div>
                        {/* <div className="form-group ">
                            <div className="ps-checkbox">
                                <input
                                    className="form-control"
                                    type="checkbox"
                                    id="remember-me"
                                    name="remember-me"
                                />
                                <label htmlFor="remember-me">Rememeber me</label>
                            </div>
                        </div> */}
                        <div className="form-group submit mb-4 mt-5">
                            <button
                                type="submit"
                                className="ps-btn ps-btn--fullwidth bg-blue color-white"
                            >
                                Login
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default SecureLogin